
      import API from "!../../../common/temp/node_modules/.pnpm/style-loader@3.3.4_webpack@5.97.1/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../common/temp/node_modules/.pnpm/style-loader@3.3.4_webpack@5.97.1/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../common/temp/node_modules/.pnpm/style-loader@3.3.4_webpack@5.97.1/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../common/temp/node_modules/.pnpm/style-loader@3.3.4_webpack@5.97.1/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../common/temp/node_modules/.pnpm/style-loader@3.3.4_webpack@5.97.1/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../common/temp/node_modules/.pnpm/style-loader@3.3.4_webpack@5.97.1/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../common/temp/node_modules/.pnpm/css-loader@5.2.7_webpack@5.97.1/node_modules/css-loader/dist/cjs.js!../../../common/temp/node_modules/.pnpm/postcss-loader@7.3.4_postcss@8.5.3_typescript@5.8.3_webpack@5.97.1/node_modules/postcss-loader/dist/cjs.js!../../../common/temp/node_modules/.pnpm/sass-loader@13.3.3_sass@1.71.1_webpack@5.97.1/node_modules/sass-loader/dist/cjs.js!./global.scss";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../common/temp/node_modules/.pnpm/css-loader@5.2.7_webpack@5.97.1/node_modules/css-loader/dist/cjs.js!../../../common/temp/node_modules/.pnpm/postcss-loader@7.3.4_postcss@8.5.3_typescript@5.8.3_webpack@5.97.1/node_modules/postcss-loader/dist/cjs.js!../../../common/temp/node_modules/.pnpm/sass-loader@13.3.3_sass@1.71.1_webpack@5.97.1/node_modules/sass-loader/dist/cjs.js!./global.scss";
       export default content && content.locals ? content.locals : undefined;
